import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import styles from "./ChatbotPanel.module.css";

const normalizeUrlToCurrentHost = (url) => {
  try {
    const targetUrl = new URL(url);
    const { protocol, host } = window.location;

    if (!targetUrl.hostname.includes("nxnearby.com")) {
      return url;
    }

    targetUrl.protocol = protocol;
    targetUrl.host = host;

    return targetUrl.toString();
  } catch {
    return url;
  }
};

const ProfileCard = ({ profile }) => {
  if (!profile) return null;

  return (
    <div className={styles.profileResultCard}>
      <div className={styles.profileIcon}>
        <PersonOutlineIcon fontSize="small" />
      </div>

      <div className={styles.profileContent}>
        <div className={styles.profileTopRow}>
          <h5 className={styles.profileTitle}>{profile.profile_name}</h5>

          <a
            href={normalizeUrlToCurrentHost(profile.profile_url)}
            target="_blank"
            rel="noreferrer"
            className={styles.profileLinkIcon}
            onClick={(e) => e.stopPropagation()}
          >
            <OpenInNewIcon fontSize="small" />
          </a>
        </div>

        <div className={styles.profileMeta}>
          <span className={styles.profileBadge}>Profile</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
